import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";

const Login = () => {
  // document.getElementsByClassName("navbar__logo").style.display = "block";
  return (
    <>
      <header>
        <Navbar />
      </header>
      <main>
        <section className="login">
          <div className="login__image-box">
            <img
              className="login__image"
              src="/images/smarthub-art.svg"
              width="400px"
              height="auto"
              alt="Two People Using SmartHub"
            />
          </div>
          <div className="login__middle-line"></div>
          <div className="login__form">
            <h3 className="login__title">Login</h3>
            <div>
              <div>
                <label className="login__label" htmlFor="email">
                  Email Address
                </label>
                <input
                  className="login__email"
                  type="email"
                  placeholder=""
                  name="email"
                  autoComplete="off"
                  required
                />
              </div>

              <div>
                <label className="login__label" htmlFor="password">
                  Password
                </label>
                <input
                  className="login__password"
                  type="password"
                  placeholder=""
                  name="password"
                  autoComplete="off"
                  required
                />
              </div>

              <input
                className="login__remember-input"
                type="checkbox"
                id="checkbox_id"
                name="remember"
              />
              <label className="login__remember-label" htmlFor="checkbox_id">
                Remember me
              </label>
              <Link className="login__sign-in" to="/home">
                Sign In
              </Link>
              <a className="login__forgot" href="/">Forgot password?</a>
            </div>
          </div>
        </section>
        <p style={{textAlign: "center", color: "#9e9e9e"}}>This is a demo front-end react UI. <br/> Click sign-in (no login needed).</p>
      </main>
    </>
  );
};

export default Login;
